import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiLeasingCalculator } from 'modules/api';
import { PagingParams } from 'modules/types/PagingParams';
import { LeasingCalculatorProductSelectionData } from 'modules/types/LeasingCalculator';
import { LeasingCalculatorData } from '../components/common/LeasingCalculatorData';

export const startLeasingCalculator = createAsyncThunk(
  'leasingCalculator/start',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiLeasingCalculator.startLeasingCalculator();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchPremadeProducts = createAsyncThunk(
  'leasingCalculator/fetchPremadeProducts',
  async (
    data: {
      params: PagingParams;
      calculatorData: LeasingCalculatorData;
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await ApiLeasingCalculator.fetchPremadeProducts(
        data.params,
        data.calculatorData,
      );
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const submitProductSelectionData = createAsyncThunk(
  'leasingCalculator/submitProductSelectionData',
  async (
    productSelectionData: LeasingCalculatorProductSelectionData,
    { rejectWithValue },
  ) => {
    try {
      const response = await ApiLeasingCalculator.submitProductSelectionData(
        productSelectionData,
      );
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const requestFinancing = createAsyncThunk(
  'leasingCalculator/requestFinancing',
  async (offerNumber: number, { rejectWithValue }) => {
    try {
      const response = await ApiLeasingCalculator.requestFinancing(offerNumber);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
